import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import api from "@/lib/api";
import SEO from "@/components/SEO";
import { shopifyImg, shopifySrcSet, SIZES_GRID_4 } from "@/lib/format";
import { JEWELRY as JEWELRY_ORDER } from "@/lib/products";

export default function JewelryPage() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/shopify/products").then(({ data }) => {
      const matched = JEWELRY_ORDER.map(j => {
        const found = data.find(p =>
          p.id === j.handle ||
          p.name?.toLowerCase() === j.name.toLowerCase() ||
          p.id?.toLowerCase().includes(j.handle.toLowerCase())
        );
        return found || null;
      }).filter(Boolean);
      setProducts(matched);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="jewelry-page" className="bg-black min-h-screen">
      <SEO title="Jewelry | AERWEAR" description="AERWEAR jewelry collection. VVS bracelets and accessories." />

      <div className="px-5 md:px-12 lg:px-20 pt-16 md:pt-24 pb-20 md:pb-28">
        <div className="mb-10 md:mb-14">
          <p className="text-[10px] uppercase tracking-[0.3em] text-white/20 font-['Inter'] mb-3">Accessories</p>
          <h1 data-testid="jewelry-heading" className="text-4xl md:text-5xl font-['Bebas_Neue'] tracking-tight text-white leading-[0.9]">Jewelry</h1>
        </div>

        {loading ? (
          <div className="flex justify-center py-20">
            <div className="flex gap-1">{[0,1,2].map(i => <div key={`dot-${i}`} className="w-1.5 h-1.5 bg-white/20 rounded-full animate-pulse" style={{ animationDelay: `${i * 0.2}s` }} />)}</div>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-6">
            {products.map(p => (
              <Link key={p.id} to={`/products/${p.id}`} data-testid={`jewelry-card-${p.id}`} className="group">
                <div className="aspect-square md:aspect-square bg-black overflow-hidden mb-3 relative">
                  {p.images?.[0] ? (
                    <>
                      <img src={shopifyImg(p.images[0], 720)} srcSet={shopifySrcSet(p.images[0])} sizes={SIZES_GRID_4} width="720" height="720" alt={p.name} className="w-full h-full object-cover opacity-90 group-hover:opacity-0 absolute inset-0 transition-opacity duration-500" loading="lazy" />
                      {p.images[1] && (
                        <img src={shopifyImg(p.images[1], 720)} srcSet={shopifySrcSet(p.images[1])} sizes={SIZES_GRID_4} width="720" height="720" alt="" className="w-full h-full object-cover opacity-0 group-hover:opacity-100 absolute inset-0 transition-opacity duration-500" loading="lazy" />
                      )}
                    </>
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-white/10"><ShoppingBag size={40} strokeWidth={1} /></div>
                  )}
                </div>
                <h3 className="text-[11px] uppercase tracking-[0.06em] font-['Inter'] text-white/70 group-hover:text-white transition-colors truncate">{p.name}</h3>
                <p className="text-sm font-['Inter'] text-[#888] mt-1">${p.price?.toFixed(2)}</p>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
